import { TitleEntityForm } from '../../features/TitleEntityForm';
import { apiRequests } from '../../shared/api/apiRequests';

const EditVacancyCategoryPage = () => (
  <TitleEntityForm
    load={apiRequests.hr.getCategory}
    update={apiRequests.hr.updateCategory}
    backTo="/HR/categories"
    savedText="Категория сохранена"
  />
);

export default EditVacancyCategoryPage;
